import {
  AppstoreOutlined,
  FileTextOutlined,
  FilterOutlined,
} from '@ant-design/icons'
import { GridViewOutlined } from '@mui/icons-material'
import React from 'react'

import type { ChipIconKey } from 'features/ask-yogi/utils/context-chip'
import {
  FREEFORM_BAR_PRESET,
  getFreeformChartTypeIcon,
} from 'features/charts-v2/types/ChartPresets'

const GLYPHS: Record<
  Exclude<ChipIconKey, { chartType: unknown }>,
  React.ReactNode
> = {
  // A chart tile with no chart type gets the charts page's own fallback glyph.
  chart: FREEFORM_BAR_PRESET.icon,
  widget: <AppstoreOutlined />,
  text: <FileTextOutlined />,
  filters: <FilterOutlined />,
  // The grid Ask Yogi's resource cards already use for a dashboard.
  dashboard: <GridViewOutlined />,
}

/** The glyph a composer context chip shows, from the key the chip carries. The
 *  composer and a saved message's chip both draw through here, so a chip looks
 *  the same where it was sent and where it is read back. */
export const ContextChipGlyph: React.FC<{ icon: ChipIconKey }> = ({ icon }) => (
  <>
    {typeof icon === 'object'
      ? getFreeformChartTypeIcon(icon.chartType)
      : GLYPHS[icon]}
  </>
)
